// src/pages/About.js  (YENİ)
import React from "react";
import ABOUT from "../data/about.json";

export default function About() {
  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">{ABOUT.aboutTitle}</h1>
          <p className="page-subtitle">{ABOUT.about}</p>
        </header>

        <div className="about-grid">
          <article className="about-card">
            <h3>{ABOUT.visionTitle}</h3>
            <p>{ABOUT.vision}</p>
          </article>
          <article className="about-card">
            <h3>{ABOUT.missionTitle}</h3>
            <p>{ABOUT.mission}</p>
          </article>
          <article className="about-card">
            <h3>{ABOUT.teamTitle}</h3>
            <p>{ABOUT.team}</p>
          </article>
        </div>
      </div>
    </section>
  );
}